<div class="overlay-wrapper" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
</div>

<main id="content" role="main" class="main">
    <!-- Content -->
    <div class="content container">
        <div >
            <nav aria-label="breadcrumb">
                <ol id="w2" class="breadcrumb">
                    <li class="breadcrumb-item">الرئيسية</li>
                    <li class="breadcrumb-item active" aria-current="page">سندات القبض</li>
                </ol>
            </nav>
        </div>
        <div class="receipt-index" >

            <h1>سندات القبض</h1>


            <div class="receipt-search">

                <h4>إصدار تقرير</h4>
                <div class="row">
                    <div class="col-4">
                        <p>من تاريخ</p>
                        <input type="date" class="form-control" [(ngModel)]="fromDate" name="fromDate">
                    </div>
                    <div class="col-4">
                        <p>الى تاريخ</p>
                        <input type="date" class="form-control" [(ngModel)]="toDate" name="toDate">
                    </div>
                </div>

                <div class="form-group mt-3">
                    <button (click)="exportToExcel()" [disabled]="fromDate==undefined||toDate==undefined" class="btn btn-primary">إصدار</button>
                     <button type="reset"
                        class="btn btn-outline-secondary">إعادة تعيين</button>
                </div>

            </div>

            <table class="mt-3 mb-3">
                <tbody>
                    <tr>
                        <td>حساب الخزينة الموحد: JO46CBJO0010000000000131000002</td>
                    </tr>
                    <tr>
                        <td>دائرة ضريبة الدخل والمبيعات: JO76CBJO0010000000000131001208</td>
                    </tr>
                    <tr>
                        <td>وزارة البيئة: JO46CBJO0010000000000131000002</td>
                    </tr>
                    <tr>
                        <td>وزارة الاستثمار: JO76CBJO0010000000000131001208</td>
                    </tr>
                    <tr>
                        <td>وزارة الداخلية: JO46CBJO0010000000000131000002</td>
                    </tr>
                </tbody>
            </table>
            <div id="w1" class="grid-view">
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th><a data-sort="invoice_no">رقم
                                الفاتورة</a></th>
                            <th><a data-sort="id">رقم الوصل</a>
                            </th>
                          
                            <th><a href="/receipt/index?receipt=&amp;sort=customer_name" data-sort="customer_name">اسم
                                    العميل</a></th>
                            <th><a data-sort="service">الخدمة</a></th>
                            <th><a data-sort="service" >مدفوع؟</a></th>
                            <th><a 
                                    data-sort="date_issued">التاريخ</a></th>
                            <th class="action-column">&nbsp;</th>
                        </tr>
                        <tr id="w1-filters" class="filters">
                            <!-- <td><input type="text" class="form-control" name="billingNumber" [(ngModel)]="billingNumber" (blur)="search()"></td> -->

                            <td><input type="text" class="form-control" name="billingNumber" [(ngModel)]="billingNumber" (blur)="search()"></td>
                            <td><input type="text" class="form-control" name="pvn" [(ngModel)]="pvn" (blur)="search()"></td>
                            <td><input type="text" class="form-control" name="userName" [(ngModel)]="userName" (blur)="search()"></td>
                            <td><input type="text" class="form-control" name="serviceName" [(ngModel)]="serviceName" (keyup)="search()"></td>
                            <td>
                                <select type="text" class="form-control" name="paid" [(ngModel)]="paid" (change)="search()">
                                    <option value="">عرض الكل</option>
                                    <option value="2">مدفوع</option>
                                    <option value="0">غير مدفوع</option>
                                </select>
                            </td>
                            <td></td>
                            <!-- <td><input type="text" class="form-control" name="issueDate" [(ngModel)]="issueDate" (blur)="search()"></td> -->
                            <!-- <td><input type="text" class="form-control" name="ReceiptSearch[id]"></td>
                            <td><input type="text" class="form-control" name="ReceiptSearch[invoice_no]"></td>
                            <td><input type="text" class="form-control" name="ReceiptSearch[customer_name]"></td>
                            <td><input type="text" class="form-control" name="ReceiptSearch[service]"></td>
                            <td><input type="text" class="form-control" name="ReceiptSearch[date_issued]"></td> -->
                            <td>&nbsp;</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of requests">
                            <td>{{item.billingNumber}}</td>
                            <td>{{item?.billingInfo?.paymentInfo?.pvNumber}}</td>
                            <td>{{item?.userName}}</td>
                            <td>{{item?.billingTyps?.service}}</td>
                            <td>{{item?.billingInfo?.billStatus=='2'?'مدفوع':'غير مدفوع'}}</td>
                            <td>{{item?.billingInfo?.issueDate |date:"dd/MM/yyyy"}}</td>
                            <td style="display: flex;">
                                <div role="button" class="px-2" (click)="showSubPaymentDetails(item?.billingInfo?.subPmtDetails)">
                                    <i class="fa fa-receipt text-primary"></i>
                                </div>
                                <a (click)="getRecipt(item.billingNumber)" role="button" title="View" aria-label="View" data-pjax="0">
                                    <i class="fa fa-eye text-primary"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <ul class="pagination">
                    <li class="prev"><span (click)="goPrevIndex()">«</span></li>

                    <li [ngClass]="item==currentIndex?'active':null"
                        *ngFor="let item of pages| slice:currentIndex-1:currentIndex+9"><a
                            (click)="updatePagination(item)">{{item}}</a></li>
                    <li class="next"><a (click)="goNextIndex()" data-page="1">»</a></li>
                </ul>
            </div>

        </div>
    </div>
    <!-- End Content -->
</main>


<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <div class="m-0" *ngFor="let item of selectedItem">
        <p> الجهة : {{item?.banksCode?.bankName}} </p>
        <p> المبلغ  : {{item?.amount}} </p>
        <hr>
    </div>
</p-dialog>
